import io from "socket.io-client";
import { apiSlice } from "../api/apiSlice";
import { messagesApi } from "../messages/messagesApi";

export const conversationsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getConversations: builder.query({
            query: (email) =>
                `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,
            transformResponse(apiResponse, meta) {
                const totalCount = meta.response.headers.get("X-Total-Count");
                return {
                    data: apiResponse,
                    totalCount,
                };
            },
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved, }
            ) {
                // create socket
                const socket = io(process.env.REACT_APP_API_URL, {
                    reconnectionDelay: 1000,
                    reconnection: true,
                    reconnectionAttemps: 10,
                    transports: ["websocket"],
                    agent: false,
                    upgrade: false,
                    rejectUnauthorized: false,
                });

                try {
                    await cacheDataLoaded;
                    socket.on("conversation", (data) => {

                        updateCachedData((draft) => {
                            const conversation = draft.data.find(
                                //eslint-disable-next-line
                                (c) => c.id == data?.data?.id
                            );

                            if (conversation?.id) {
                                //eslint-disable-next-line
                                draft.data = [{ ...conversation, message: data.data.message, timestamp: data.data.timestamp }, ...draft.data.filter(c => c.id != data.data.id)];
                                // conversation.message = data?.data?.message;
                                // conversation.timestamp = data?.data?.timestamp;
                            } else {
                                // do nothing
                                draft.data.unshift(data.data);
                                draft.totalCount = Number(draft.totalCount) + 1;
                            }
                        });
                    });
                } catch (err) { }

                await cacheEntryRemoved;
                socket.close();
            },
        }),
        getMoreConversations: builder.query({
            query: ({ email, page }) =>
                `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,
            async onQueryStarted({ email }, { queryFulfilled, dispatch }) {
                try {
                    const conversations = await queryFulfilled;
                    if (conversations?.data?.length > 0) {
                        // update conversation cache pessimistically start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getConversations",
                                email,
                                (draft) => {
                                    return {
                                        data: [
                                            ...draft.data,
                                            ...conversations.data,
                                        ],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                        // update messages cache pessimistically end
                    }
                } catch (err) { }
            },
        }),
        getConversation: builder.query({
            query: ({ userEmail, participantEmail }) =>
                `/conversations?participants_like=${userEmail}-${participantEmail}&&participants_like=${participantEmail}-${userEmail}`,
        }),
        addConversation: builder.mutation({
            query: ({ sender, data }) => ({
                url: "/conversations",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                console.log("file: conversationsApi.js ~ line 93 ~ onQueryStarted ~ arg", arg)
                const tempID = `tempId-${Math.round(Math.random() * 100)}`;

                // optimistic cache update start
                const pathResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getConversations",
                        arg.sender,
                        (draft) => {
                            draft.data.unshift({ ...arg.data, id: tempID });
                            draft.totalCount = Number(draft.totalCount) + 1;
                        }
                    )
                );
                // optimistic cache update end

                try {
                    const conversation = await queryFulfilled;
                    if (conversation?.data?.id) {

                        // updating conversation id - start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getConversations",
                                arg.sender,
                                (draft) => {
                                    // removing temp item
                                    draft.data = draft.data.filter(c => c.id !== tempID);

                                    // const toUpdate = draft.data.find(c => c.id === tempID);
                                    // toUpdate.id = conversation.data.id;
                                }
                            )
                        ); // updating conversation id - end

                        // updating getConversation caches - start
                        dispatch(apiSlice.util.updateQueryData(
                            "getConversation",
                            { userEmail: arg.sender, participantEmail: arg.data.users.find(e => e.email !== arg.sender).email },
                            draft => { draft.push(conversation.data) }
                        ))
                        // updating getConversation caches - end

                        // silent entry to message table
                        const users = arg.data.users;
                        const senderUser = users.find(
                            (user) => user.email === arg.sender
                        );
                        const receiverUser = users.find(
                            (user) => user.email !== arg.sender
                        );

                        dispatch(
                            messagesApi.endpoints.addMessage.initiate({
                                conversationId: conversation?.data?.id,
                                sender: senderUser,
                                receiver: receiverUser,
                                message: arg.data.message,
                                timestamp: arg.data.timestamp,
                            })
                        );
                    } else {
                        pathResult.undo();
                    }
                } catch (error) {
                    pathResult.undo();
                }
            },
        }),
        editConversation: builder.mutation({
            query: ({ id, data, sender }) => ({
                url: `/conversations/${id}`,
                method: "PATCH",
                body: data,
            }),
            onQueryStarted: async (arg, { queryFulfilled, dispatch }) => {
                // optimistic conversation cache update start
                const pathResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getConversations",
                        arg.sender,
                        (draft) => {
                            const draftConversation = draft.data.find(
                                //eslint-disable-next-line
                                (c) => c.id == arg.id
                            );
                            //eslint-disable-next-line
                            draft.data = [{ ...draftConversation, message: arg.data.message, timestamp: arg.data.timestamp }, ...draft.data.filter(c => c.id != arg.id)];
                        }
                    )
                );
                // optimistic conversation cache update end

                try {
                    const conversation = await queryFulfilled;
                    if (conversation?.data?.id) {
                        // silent entry to message table
                        const users = arg.data.users;
                        const senderUser = users.find(
                            (user) => user.email === arg.sender
                        );
                        const receiverUser = users.find(
                            (user) => user.email !== arg.sender
                        );

                        const res = await dispatch(
                            messagesApi.endpoints.addMessage.initiate({
                                conversationId: conversation?.data?.id,
                                sender: senderUser,
                                receiver: receiverUser,
                                message: arg.data.message,
                                timestamp: arg.data.timestamp,
                            })
                        ).unwrap();

                        // update messages cache pessimistically start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getMessages",
                                res.conversationId.toString(),
                                (draft) => {
                                    // eslint-disable-next-line
                                    const msg = draft.messages.find(msg => msg.id == res.id);
                                    if (msg) {
                                        console.log("duplicate"); return;
                                    }
                                    draft.messages.push(res);
                                }
                            )
                        );
                        // update messages cache pessimistically end

                        // sorting last conversation
                        apiSlice.util.updateQueryData(
                            "getConversations",
                            arg.sender,
                            (draft) => {
                                console.log("file: conversationsApi.js ~ line 225 ~ onQueryStarted: ~ draft", draft)
                                // const draftConversation = draft.data.find(
                                //     (c) => c.id == arg.id
                                // );
                                // const newList = draft.data.filter(c => c.id != arg.id);
                                // const l = [draftConversation, ...newList];
                                // console.log(l);
                                // draft.data = l;
                            }
                        )

                    }
                } catch (err) {
                    pathResult.undo();
                }
            },
        }),
    }),
});

export const {
    useGetConversationsQuery,
    useGetConversationQuery,
    useAddConversationMutation,
    useEditConversationMutation,
} = conversationsApi;